import { render, staticRenderFns } from "./LogDeleteReceiveNumber.vue?vue&type=template&id=25a5d395&"
import script from "./LogDeleteReceiveNumber.vue?vue&type=script&lang=js&"
export * from "./LogDeleteReceiveNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports